module.exports = __webpack_public_path__ + "img/76ne.c2302e1f.svg";